import { environment } from './../../../environments/environment';
import { CertificadoService } from './../../shared/service/certificado/certificado.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Certificado, ExcluirCertificado } from '../../shared/index';
import { LoginService } from '../../shared/service/login/login.service';
import { UtilService } from '../../shared/service/util/util.service';
import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TourState } from 'ngx-tour-core';
import { TourInterativo } from '../../shared/Tour/TourInterativo';
import { TourService } from 'ngx-tour-ngx-popper';
import { Router } from '@angular/router';
import { ConfirmDialogService } from '../../shared/service/confirm-dialog/confirm-dialog.service';

declare var $: any;

@Component({
    selector: 'app-certificado-list',
    templateUrl: './certificado-list.component.html',
    styleUrls: ['./certificado-list.component.css']
})
export class CertificadoListComponent implements OnInit {

    certificados: Certificado[];
    certificado: Certificado;
    excluirCertificado = new ExcluirCertificado();
    idUsuario: number;
    idOrganizacao: number;
    statusFatores: any = {};
    nomeUsuario: string;
    showSpinner: boolean = false;
    hidePin: boolean = true;
    hideToken: boolean = true;

    dataSource: MatTableDataSource<Certificado>
    displayedColumns: string[] = ['status', 'emitido', 'validoAte', 'emitidoPara', 'emissor', 'acao'];
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    @ViewChild('excluirCertificadoDialog', { static: true }) excluirCertificadoDialog: TemplateRef<any>;
    private excluirCertificadoDialogRef: MatDialogRef<TemplateRef<any>>;

    @ViewChild('tourDialog', { static: true }) tourDialog: TemplateRef<any>;
    private tourDialogRef: MatDialogRef<TemplateRef<any>>;

    constructor(private certificadoService: CertificadoService
        , private loginService: LoginService
        , private router: Router
        , private tourService: TourService
        , private tourInterativo: TourInterativo
        , private dialog: MatDialog
        , private dialogService: ConfirmDialogService
        , private utilService: UtilService) {

        this.idUsuario = JSON.parse(localStorage.getItem("currentUser")).id;
        this.idOrganizacao = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
        this.nomeUsuario = JSON.parse(localStorage.getItem("currentUser")).nome.split(' ')[0];
        this.tourInterativo.getPassosTour();
    }

    ngOnInit() {
        this.showSpinner = true;

        this.buscaStatusFatores(() => {
            this.getCertificados(() => {
                this.exibirTourDialog();
            });
        }); 
    }

    getCertificados(callback: () => void) {
        this.certificadoService.getListaCertificados(this.idUsuario, this.idOrganizacao)
            .then((carteiraCertificados) => {
                this.certificados = carteiraCertificados.certificados;
                this.dataSource = new MatTableDataSource(this.certificados);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                callback();
            }).catch(error => {
                this.showSpinner = false;
                this.getError(error);
            });
    }

    openConfirmDialogRevoke(certificado) {
        const options = {
          title: 'Revogar certificado',
          message: 'Deseja revogar o certificado ' + certificado.cn + '?',
          cancelText: 'Cancelar',
          confirmText: 'Revogar'
        };

        this.dialogService.open(options);

        this.dialogService.confirmed().subscribe(confirmed => {
          if (confirmed) {
            this.revoke(certificado);
          }
        });
    }

    revoke(certificado: Certificado) {
      let urlSubdominio = this.utilService.getSubdominio();
      console.log("Subdominio: " + urlSubdominio);
      if(urlSubdominio.includes('fenacon')){
        console.log(environment.revokeFenaconUrl)
        window.open(environment.revokeFenaconUrl, '_blank');
      } else {
        console.log(certificado.urlRevogacaoGAR)
        window.open(certificado.urlRevogacaoGAR, '_blank');
      }
    }

    openConfirmDialogDelete(certificado) {
        const options = {
          title: 'Excluir certificado',
          message: 'Deseja excluir o certificado ' + certificado.cn + '?',
          cancelText: 'Cancelar',
          confirmText: 'Excluir'
        };

        this.dialogService.open(options);

        this.dialogService.confirmed().subscribe(confirmed => {
          if (confirmed) {
            this.openDialogDelete(certificado); 
          }
        });
    }

    openDialogDelete(certificado: Certificado) {
        this.certificado = certificado;
        this.excluirCertificadoDialogRef = this.dialog.open(this.excluirCertificadoDialog, this.utilService.configuracaoDialog());
    }

    excluir() {
        this.excluirCertificado.idCertificado = this.certificado.id;

        this.certificadoService.deleteCertificado(this.excluirCertificado, this.idUsuario, this.idOrganizacao).then(
            () => {
                this.excluirCertificado = new ExcluirCertificado();
                this.sucessoExclusaoDialog(this.certificado);
                this.excluirCertificadoDialogRef.close();
            }).catch(error => {
                this.erroExclusaoDialog(this.certificado, error);
                this.excluirCertificadoDialogRef.close();
            });
    }

    sucessoExclusaoDialog(certificado) {
        this.excluirCertificadoDialogRef.close();
        const options = {
          title: 'Certificado Excluido',
          message: 'O certificado ' + certificado.cn + ' foi excluido com sucesso.',
          confirmText: 'Ok'
        };

        this.dialogService.open(options);

        this.getCertificados(() => {});
    }

    erroExclusaoDialog(certificado, erro) {
        const options = {
          title: 'Erro: '+ erro,
          message: 'O certificado ' + certificado.cn + ' não pôde ser excluido!', 
          confirmText: 'Ok'
        };
    
        this.dialogService.open(options);
    }

    getError(error) {
        if (error.status === 401 || error.status === 403) {
            this.loginService.logout();
        } else {
            let err;

            if (error.status === 0) {
                err = 'Servidor indisponível!';
            } else {
                err = error.message || error;
            }
            this.utilService.showError(err);
        }
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    editar(certId) {
        this.router.navigate(['/certificado-form', { id: certId }]);
    }

    buscaStatusFatores(callback: () => void) {
        this.certificadoService.getStatusFatores(this.idUsuario, this.idOrganizacao).subscribe(
            res => {
                this.statusFatores = res;
            }
        );
        callback();
    }

    exibirTourDialog() {
        this.showSpinner = false;

        if (this.certificados.length == 0 && (!this.statusFatores.usuarioCadastrouPin || !this.statusFatores.usuarioCadastrouTokenOtp)) {
            this.tourDialogRef = this.dialog.open(this.tourDialog, this.utilService.configuracaoDialog());
        }
    }

    iniciaTour() {
        this.tourService.toggle();

        if (this.tourService.getStatus() == TourState.ON) {
            this.tourDialogRef.close();
        }
    }

    finalizaTour() {
        this.tourService.end();
        this.tourDialogRef.close();
    }

    cancelar() {
        this.excluirCertificado = new ExcluirCertificado();
        this.excluirCertificadoDialogRef.close();
    }
}
